module.exports = __webpack_public_path__ + "media/images/spotify_attribution-5858dc840b62924726fc648b2e8c3b08.png";